import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { PathPickBasketTab } from "@/features/pathpick/features/basket/types";

interface Props {
  tab: PathPickBasketTab;
  hasQuery: boolean;
  hasFilter: boolean;
}

// 탭별 빈 목록 안내 — 카드 본문 안에 들어가는 패널이다.
// 담은 상품 자체가 0개일 때의 전체 빈 화면은 PathPickBasketNoResult가 담당한다.
function PathPickBasketListEmpty({ tab, hasQuery, hasFilter }: Props) {
  const { t } = useI18nHelper();

  // 검색어/필터 때문에 0건인지, 탭 자체가 비었는지에 따라 안내가 달라진다.
  // (검색어가 더 구체적인 안내라 검색어를 먼저 본다)
  const prefix = hasQuery
    ? "path_pick:basket.list.empty_search"
    : hasFilter
    ? "path_pick:basket.list.empty_filter"
    : `path_pick:basket.list.empty_${tab}`;

  return (
    <Flex
      flexDirection={"column"}
      gap={"4px"}
      alignItems={"center"}
      justifyContent={"center"}
      padding={"64px 16px"}
      borderRadius={"8px"}
      background={"#F7F9FA"}
    >
      <Text textStyle={"body-md-bold"} color={"#444440"}>
        {t(`${prefix}_title`)}
      </Text>
      <Text textStyle={"body-sm-medium"} color={"#8F8F8C"}>
        {t(`${prefix}_desc`)}
      </Text>
    </Flex>
  );
}

export default PathPickBasketListEmpty;
